module.exports = __webpack_public_path__ + "img/bg-baby.d0657fee.png";